/**
 * Cifra que sube de 0 a su valor (spec 009-dashboard-camino, FR-003)
 *
 * Se anima al montar y cada vez que cambia el valor. Sin `matchMedia`
 * (tests) o con `prefers-reduced-motion: reduce` devuelve el valor final.
 */

import { useEffect, useState } from 'react';

export const COUNT_UP_DURATION_MS = 1400;

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function useCountUp(target: number, durationMs: number = COUNT_UP_DURATION_MS): number {
  const [value, setValue] = useState(() => (prefersReducedMotion() ? target : 0));

  useEffect(() => {
    if (prefersReducedMotion() || durationMs <= 0) {
      setValue(target);
      return;
    }
    let frame = 0;
    // Siempre el mismo reloj: el argumento de requestAnimationFrame no coincide
    // con performance.now() en todos los entornos.
    const start = performance.now();
    const tick = () => {
      const x = Math.min(1, Math.max(0, (performance.now() - start) / durationMs));
      const eased = 1 - Math.pow(1 - x, 3);
      setValue(target * eased);
      if (x < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, durationMs]);

  return value;
}
